import React, { useState, useRef, useEffect, Fragment } from "react";
import { Link } from "react-router-dom";
import PageTitle from "../../../layouts/PageTitle";
import * as Yup from "yup";
import { Field, FormikProvider, useFormik } from "formik";
import { Form, Label } from "reactstrap";
import { Row, Col, Modal, Accordion } from "react-bootstrap";
import CustomSelect from "../../../Custom/CustomSelect";
import { TimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import PaginationButtons from "../../../Custom/Pagination";
import CustomInput from "../../../Custom/CustomInput";
import CustomFlatpickr from "../../../Custom/CustomFlatpicker";
const ComplaintManagment = () => {
  const [complaintStatusModal, setComplaintStatusModal] = useState(false);
  const [selectStartTime, handleChangeStartTime] = useState(new Date());
  const [selectEndTime, handleChangeEndTime] = useState(new Date());

  const [recordCount, setRecordCount] = useState(2);
  const [currentPage, setCurrentPage] = useState(1);
  const [currentSizePerPage, setCurrentSizePerPage] = useState(10);

  const validationSchemaComplaintStatus = Yup.object().shape({
    Remark: Yup.string().required("Remark is required field"),
  });

  const formikComplaintStatus = useFormik({
    validationSchema: validationSchemaComplaintStatus,
    onSubmit: (values, formikHelpers) =>
      handleValidSubmitComplaintStatus(values, formikHelpers),
    initialValues: {
      Remark: "",
    },
    validateOnBlur: false,
  });
  const { setValues, setFieldValue, handleValidSubmitComplaintStatus } =
    formikComplaintStatus;

  const optionStaff = [
    { label: "Yana Suthar", value: 1 },
    { label: "Nilesh Soni", value: 2 },
    { label: "Nishit Kachiya", value: 3 },
    { label: "Chirag Suthar", value: 4 },
  ];

  const getData = async (page = 1, sizePerPage = 10) => {
    setCurrentPage(page);
  };

  return (
    <>
      <Fragment>
        <PageTitle motherMenu="Transaction" activeMenu="Complaint Managment" />

        <div className="form-head d-flex mb-3 mb-md-4 align-items-start">
          <div className="input-group search-area ml-auto d-inline-flex mr-3">
            <input
              type="text"
              style={{ height: "36px" }}
              className="form-control"
              placeholder="Search here"
            />
            <div className="input-group-append">
              <button type="button" className="input-group-text">
                <i className="flaticon-381-search-2" />
              </button>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-12">
            <div className="table-responsive">
              <div
                id="SchedulePackageAndHealthCheckup_List"
                className="dataTables_wrapper no-footer"
              >
                <table
                  id="example5"
                  className="table table-striped SchedulePackageAndHealthCheckup_List mb-4 dataTablesCard fs-14 dataTable no-footer"
                  role="grid"
                  aria-describedby="example5_info"
                >
                  <thead>
                    <tr role="row">
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Complaint No.: activate to sort column ascending"
                        style={{ width: "10%" }}
                      >
                        Complaint No.
                      </th>

                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Complaint Type: activate to sort column ascending"
                        style={{ width: "14%" }}
                      >
                        Complaint Type
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Complaint By: activate to sort column ascending"
                        style={{ width: "15%" }}
                      >
                        Complaint By
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Order No.: activate to sort column ascending"
                        style={{ width: "15%" }}
                      >
                        Order No.
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Complaint Topic: activate to sort column ascending"
                        style={{ width: "20%" }}
                      >
                        Complaint Topic
                      </th>

                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Complaint Remark: activate to sort column ascending"
                        style={{ width: "15%" }}
                      >
                        Remark
                      </th>
                      <th
                        className="sorting"
                        tabIndex={0}
                        aria-controls="example5"
                        rowSpan={1}
                        colSpan={1}
                        aria-label="Actions: activate to sort column ascending"
                        style={{ width: "10%" }}
                      >
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr role="row" className="odd">
                      <td>COM0000001</td>
                      <td>Staff</td>
                      <td>Yana Suthar</td>
                      <td>ON00000001</td>
                      <td>Using Mobile Phone</td>
                      <td>Not giving proper Service</td>
                      <td style={{ textAlign: "center" }}>
                        {/* <div className="d-flex"> */}
                        <Link
                          // to="#"
                          className="btn btn-light shadow btn-xs sharp"
                          title="CLosed"
                          onClick={() => {
                            setComplaintStatusModal(true);
                          }}
                        >
                          <i
                            className="fa fa-lock"
                            // className="fa fa-unlock"

                            style={{ color: "black" }}
                          ></i>
                        </Link>
                        {/* </div> */}
                      </td>
                    </tr>
                    <tr role="row" className="odd">
                      <td>COM0000002</td>
                      <td>Client</td>
                      <td>Hitesh Vaghela</td>
                      <td>ON00000012</td>
                      <td>Always Late</td>
                      <td>Never come on time</td>
                      <td style={{ textAlign: "center" }}>
                        {/* <div className="d-flex"> */}
                        <Link
                          // to="#"
                          className="btn btn-light shadow btn-xs sharp"
                          title="Open"
                          onClick={() => {
                            setComplaintStatusModal(true);
                          }}
                        >
                          <i
                            // className="fa fa-lock"
                            className="fa fa-unlock"
                            style={{ color: "red" }}
                          ></i>
                        </Link>
                        {/* </div> */}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div className="d-sm-flex text-center justify-content-between align-items-center">
                  <div
                    className="dataTables_info"
                    id="example5_info"
                    role="status"
                    aria-live="polite"
                  >
                    Showing{" "}
                    {recordCount > 0
                      ? (currentPage - 1) * currentSizePerPage + 1
                      : 0}{" "}
                    to{" "}
                    {recordCount > currentPage * currentSizePerPage
                      ? currentPage * currentSizePerPage
                      : recordCount}{" "}
                    of {recordCount} entries
                  </div>
                  <div className="paging_simple_numbers d-flex  justify-content-center align-items-center">
                    <PaginationButtons
                      totalPages={recordCount / currentSizePerPage}
                      currentPage={currentPage}
                      getData={getData}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal
          className="modal fade"
          show={complaintStatusModal}
          onHide={setComplaintStatusModal}
        >
          <FormikProvider value={formikComplaintStatus}>
            <Form onSubmit={formikComplaintStatus.handleSubmit}>
              <div className="modal-header">
                <h4 className="modal-title fs-20">Complaint Status</h4>
                <button
                  type="button"
                  className="btn close"
                  onClick={() => setComplaintStatusModal(false)}
                >
                  <span>×</span>
                </button>
              </div>
              <div className="modal-body">
                <Row>
                  <Col lg={12}>
                    <Row>
                      <Col lg={5}>
                        <b>Complaint No.</b>
                      </Col>
                      <Col lg={1}>:</Col>
                      <Col lg={6}>COM0000001</Col>
                    </Row>
                  </Col>
                  <Col lg={12}>
                    <Row>
                      <Col lg={5}>
                        <b>Complaint Type</b>
                      </Col>
                      <Col lg={1}>:</Col>
                      <Col lg={6}>Client</Col>
                    </Row>
                  </Col>
                  <Col lg={12}>
                    <Row>
                      <Col lg={5}>
                        <b>Complaint By</b>
                      </Col>
                      <Col lg={1}>:</Col>
                      <Col lg={6}>Yana Suthar</Col>
                    </Row>
                  </Col>
                  <Col lg={12}>
                    <Row>
                      <Col lg={5}>
                        <b>Order No.</b>
                      </Col>
                      <Col lg={1}>:</Col>
                      <Col lg={6}>ON00000012</Col>
                    </Row>
                  </Col>
                  <Col lg={12}>
                    <Row>
                      <Col lg={5}>
                        <b>Complaint Topic</b>
                      </Col>
                      <Col lg={1}>:</Col>
                      <Col lg={6}>Always Late</Col>
                    </Row>
                  </Col>
                  <Col lg={12}>
                    <Row>
                      <Col lg={5}>
                        <b>Complaint Remark</b>
                      </Col>
                      <Col lg={1}>:</Col>
                      <Col lg={6}>Never come on time</Col>
                    </Row>
                  </Col>
                </Row>
                <hr></hr>
                <Row>
                  <Col lg={12}>
                    <Field
                      label={"Remark"}
                      type="textarea"
                      name="Remark"
                      placeholder={"Enter Remark"}
                      component={CustomInput}
                      rows={3}
                      style={{ resize: "none" }}
                      required
                    />
                  </Col>
                </Row>
              </div>
              <div className="modal-footer">
                <button type="submit" className="btn btn-xs btn-primary">
                  Submit
                </button>
                <button
                  type="button"
                  onClick={() => setComplaintStatusModal(false)}
                  className="btn btn-xs btn-light"
                >
                  {" "}
                  <i className="flaticon-delete-1"></i> Cancel
                </button>
              </div>
            </Form>
          </FormikProvider>
        </Modal>
      </Fragment>
    </>
  );
};

export default ComplaintManagment;
